import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

function AccountActionPage() {
  const [message, setMessage] = useState('Processing your request...');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setMessage('Error: No security token provided in the link.');
      return;
    }


// Force API to always hit the prod domain where PHP lives

const apiDomain = window.location.hostname.includes('beta.')
  ? 'https://beta.flightiq.app'
  : 'https://flightiq.app';

fetch(`${apiDomain}/authapi/account_action.php?token=${token}`, { 
  method: "GET",
  headers: {
    "Accept": "application/json"
  },
  credentials: "include" // keep if your PHP session/cookies matter
})
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }
    return res.json();
  })
  .then(data => {
    setMessage(data.message || 'An unexpected error occurred.');
  })
  .catch(error => {
    console.error('API call failed:', error);
    setMessage('Failed to process your request. Please try again later or contact support.');
  });
  }, [location]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      textAlign: 'center',
      padding: '2rem',
      boxSizing: 'border-box',
      paddingTop: '80px', 
    }}>
      <h2>Account Action</h2>
      <p style={{ fontSize: '1.2rem', maxWidth: '500px', lineHeight: '1.6' }}>
        {message}
      </p>
      <Link to="/login" style={{ marginTop: '2rem', color: '#61dafb', fontSize: '1.1rem' }}>
        Go to Login Page
      </Link>
    </div>
  );
}

export default AccountActionPage;